import Translations from "@translate/components/Chat/JsonRenderComponents/trackerSignalMetaLabel";
import { I18nUtil } from "@utils/i18n";

import { formatTrackerSignalTrackedOnTime } from "./utils";

const I18n = I18nUtil.createScoped(Translations);

export const buildTrackerSignalTrackedOnLabel = (
  trackedAtMs: number,
  locale?: string,
): string =>
  I18n.t("signal tracked on %{time}", {
    time: formatTrackerSignalTrackedOnTime(trackedAtMs, locale),
    locale,
  });
